import Vue from 'vue';
import Vuex from 'vuex';

import api from './modules/api';
import locale from '@shared/locale/store';
import tandcs from './modules/tandcs';
import dataPrivacy from './modules/dataprivacy';
import cookiePolicy from './modules/cookiepolicy';
import loggedIn from './modules/loggedIn';

Vue.use(Vuex);

// For dev only, remove before actually merging and building for production
Vue.config.devtools = true;

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        api,
        locale,
        tandcs,
        dataPrivacy,
        cookiePolicy,
        loggedIn
    },
    strict: debug,
});



// WEBPACK FOOTER //
// ./shared/store/index.js